import { FeatureMap, FeatureValue } from '../../types';

export const isEnabled = (value: FeatureValue) => value === 'Release';

// For Example Use Only
export const isS4PodFirstFlagEnabled = (features: FeatureMap) => {
  const FEATURE = 's4pod-first-flag';
  return isEnabled(features[FEATURE]);
};

// Site-wide data delay alert
export const isS4PodShowSiteAlertEnabled = (features: FeatureMap) => {
  const FEATURE = 's4pod-show-site-alert';
  return isEnabled(features[FEATURE]);
};

export const isS4PodHomeViewForAllEnabled = (features: FeatureMap) => {
  return isEnabled(features['s4pod-home-view-for-all']);
};

export const isS4PodHomeCardPlaylistEnabled = (features: FeatureMap) => {
  return isEnabled(features['s4pod-home-card-playlists']);
};
